import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { mapState } from "vuex";
import help from "../assets/js/help";
export default {
  name: "ListOtherActivityItem",
  data: function data() {
    return {
      expand: false
    };
  },
  props: {
    item: {
      type: Object,
      default: {
        applicationNum: "3",
        coverImgUrl: "/d/file/custom/30018/file/202301/1673339655419736.png",
        endTime: "2023-02-11T11:43:55Z",
        goodsNum: "10",
        goodsPrice: "10",
        id: "5",
        invitationNum: "0",
        inviteNum: "10",
        isMe: "0",
        startTime: "2023-01-11T11:43:55Z",
        status: "1",
        title: "鹅鹅鹅鹅哈哈哈哈"
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState(["uid", "token", "time", "isTest", "totalIngral"])), {}, {
    statusText: function statusText() {
      return ["已删除", "未审核", "进入活动", "不通过", "进入活动"][this.item.status - 0 + 1];
    },
    params: function params() {
      var _this$item = this.item,
          startTime = _this$item.startTime,
          id = _this$item.id,
          status = _this$item.status;
      return {
        "addTime": this.startTime,
        "addr": "string",
        "fromMobile": "string",
        "id": id - 0,
        "mobile": "string",
        "name": "string",
        "platformSource": 0,
        "status": status - 0,
        "targetId": 0,
        "targetType": 0,
        "time": this.time,
        "token": this.token,
        "uid": this.uid - 0
      };
    },
    rule: function rule() {
      var _this$item2;

      return ((_this$item2 = this.item) === null || _this$item2 === void 0 ? void 0 : _this$item2.summary) || "";
    },
    integral: function integral() {
      var _this$item3;

      return ((_this$item3 = this.item) === null || _this$item3 === void 0 ? void 0 : _this$item3.integral) || "";
    }
  }),
  methods: {
    joinActivity: function joinActivity() {
      var _this = this;

      this.axios.post("/api/activity/invitation-add", JSON.stringify(this.params), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this.logout, _this.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    onClickList: function onClickList() {
      var _id = this.item.targetId.toString();

      var _targetType = this.item.targetType.toString();

      if (!isInApp()) {
        help.openUrl(_id, _targetType, this.item.h5Url);
      } else {
        help.openOriginal(_id, _targetType, "", "", this.item.h5Url);
      }
    }
  }
};